import { InjectionToken } from '@angular/core';
import { IHubProxy } from './IHubProxy';

export const PushHubToken = new InjectionToken<IHubProxy>('PushHub');
